import { LINEITEMS_DATAGRID_COLUMNKEYS } from 'app-entities/trace/components';

export const DATAGRID_COLUMNS = [
  LINEITEMS_DATAGRID_COLUMNKEYS.NAME,
  LINEITEMS_DATAGRID_COLUMNKEYS.TRACE_LEVEL_ID,
  LINEITEMS_DATAGRID_COLUMNKEYS.TIMESTAMP,
  LINEITEMS_DATAGRID_COLUMNKEYS.DETAILS,
];
